import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { Search, Dropdown } from 'lib/components';

import { VerificationStatusOptions } from 'lib/const/VerificationsStatusOptions';
import { ResellersDropdown } from './ResellersDropdown';
import { Flex } from 'lib/components/styles/layout';
import Switch from 'app/pages/design/landingPageBuilder/components/Switch';
import { RESELLER_IDS } from 'lib/const/Resellers';

const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  justify-content: flex-start;
  gap: 12px;
  align-items: flex-start;
`;

const ToggleContainer = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  ${({ width }) => (!!width?.length ? `width: ${width};` : '')}
  height: 40px;
  align-items: center;
`;

const ToggleLabel = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black[100]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

type FilterProps = {
  marginRight?: number;
  width?: number;
};
const Filter = styled.div<FilterProps>`
  min-width: 224px;
  width: ${props => `${props.width}px` || 'auto'};
  margin-right: ${props => `${props.marginRight}px` || '0px'};
`;

type Props = {
  prevSearch?: string;
  statusFilter?: number;
  resellerFilter?: number;
  showResellerFilter?: boolean;
  onSelectStatus(statusValue: number): void;
  onSelectReseller(resellerId: number): void;
  onSearch(search: string): void;
  isSetupComplete?: boolean;
  handleSetUpToggle?: () => void;
  resellerId?: number;
};

export const SearchAndFilter = ({
  prevSearch,
  statusFilter,
  resellerFilter,
  showResellerFilter,
  onSelectStatus,
  onSelectReseller,
  onSearch,
  isSetupComplete,
  handleSetUpToggle,
  resellerId,
}: Props) => {
  const isCDK = resellerId?.toString() === RESELLER_IDS.CDK;
  const themes = useTheme();

  return (
    <FiltersContainer>
      <Filter width={536}>
        <Search
          placeholder='Search by business name, id, admin name or email...'
          onSearch={onSearch}
          prevSearch={prevSearch}
        />
      </Filter>

      <Filter width={224}>
        <Dropdown
          menuPortalTarget={document.body}
          zIndexProp={1}
          menuPlacement={'bottom'}
          height={40}
          creatable={false}
          className='dropdown'
          placeholder={'Filter by Statuses'}
          value={VerificationStatusOptions.find(
            option => option.value === statusFilter
          )}
          onChange={value => onSelectStatus(value.value)}
          options={VerificationStatusOptions}
        />
      </Filter>
      <Filter width={224}>
        <Flex gap='8px'>
          {showResellerFilter && (
            <ResellersDropdown
              zIndexProp={1}
              showAllResellerOption={true}
              resellerFilter={resellerFilter}
              onSelectReseller={onSelectReseller}
            />
          )}
          {!!isCDK && (
            <ToggleContainer width='200'>
              <ToggleLabel>CDK Setup Complete</ToggleLabel>
              <Switch
                id={'switch-only-my-c'}
                isOn={!!isSetupComplete}
                onColor={themes.colors.primary[100]}
                handleToggle={() => {
                  handleSetUpToggle && handleSetUpToggle();
                }}
              />
            </ToggleContainer>
          )}
        </Flex>
      </Filter>
    </FiltersContainer>
  );
};
